import {
  Flex,
  HStack,
  VStack,
  Text,
  Divider,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';

interface HeaderProps {
  organizationLogo: string;
  organizationName: string;
  clientName: string;
  policyNumber: string;
}

const Header = ({
  organizationLogo,
  organizationName,
  clientName,
  policyNumber,
}: HeaderProps) => {
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Card bg={bgColor} p={8} borderWidth="2px">
      <VStack spacing={6} align="stretch">
        {/* Logo and Organization Name */}
        <Flex justify="space-between" align="center" flexWrap="wrap" gap={4}>
          <HStack spacing={4}>
            <Image
              src={organizationLogo}
              alt={`${organizationName} logo`}
              maxH="60px"
              maxW="200px"
              objectFit="contain"
            />
          </HStack>

          <VStack align={{ base: 'start', md: 'end' }} spacing={0}>
            <Text fontSize="sm" color="gray.500" fontWeight="500">
              Secure Document Portal
            </Text>
          </VStack>
        </Flex>

        <Divider />

        <HStack spacing={8} flexWrap="wrap">
          <VStack align="start" spacing={1}>
            <Text fontSize="sm" color="gray.500" fontWeight="500">
              Client Name
            </Text>
            <Text fontSize="md" fontWeight="600">
              {clientName}
            </Text>
          </VStack>

          <VStack align="start" spacing={1}>
            <Text fontSize="sm" color="gray.500" fontWeight="500">
              Policy Number
            </Text>
            <Text fontSize="md" fontWeight="600">
              {policyNumber}
            </Text>
          </VStack>
        </HStack>
      </VStack>
    </Card>
  );
};

export default Header;
